import { Clock } from "lucide-react";
import type { FpToolCallMessagePart } from "../../../../../schemas/codegen";
import { SimpleMessageCard } from "./shared";

interface WaitProps {
  part: FpToolCallMessagePart;
}

export function Wait({ part }: WaitProps) {
  const isComplete = part.status === "complete";
  const isPending = part.status === "pending" || part.status === "executing";

  // Extract duration from args
  const durationSeconds = part.args?.durationSeconds as number;

  const displayName = isPending
    ? `Waiting for ${durationSeconds} second${durationSeconds === 1 ? "" : "s"}...`
    : isComplete
      ? `Waited for ${durationSeconds} second${durationSeconds === 1 ? "" : "s"}`
      : "Wait failed";

  return (
    <SimpleMessageCard status={part.status} icon={Clock} title={displayName} />
  );
}
